module.exports = __webpack_public_path__ + "img/video-icon.bca9302c.png";